(function () {
  const tabsLinks = document.querySelectorAll('.js-tabsLink[href^="#"]');
  const tabsContents = document.querySelectorAll(".js-tabsContent");

  // Vérifiez si les éléments existent avant de les manipuler
  if (tabsLinks.length === 0 || tabsContents.length === 0) {
    return; // Aucun élément trouvé, sortie de la fonction
  }

  tabsLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      // Supprimez la classe "is-active" de tous les liens
      tabsLinks.forEach((all) => {
        all.classList.remove("is-active");
      });
      // Ajoutez la classe "is-active" au lien actuel
      link.classList.add("is-active");

      const targetId = link.getAttribute("href").substring(1);
      // Supprimez la classe "is-open" de tous les contenus
      tabsContents.forEach((content) => {
        content.classList.remove("is-open");
      });
      // Ajoutez la classe "is-open" au contenu cible
      const tabsContent = document.getElementById(targetId);
      if (tabsContent) {
        tabsContent.classList.add("is-open");
      }
    });
  });
})();
